// window.URL_API = 'https://api.k8s.sprinta.com.br/'
window.URL_API = 'https://api.sprinta.com.br/'
window.URL_API_USER = 'https://api.sprinta.com.br/profile_service/'
window.URL_API_EVENT = 'https://api.sprinta.com.br/event_service/'
window.URL_API_CHALLENGE = 'https://api.sprinta.com.br/challenge_service/'
window.URL_API_EXPERIENCE = 'https://api.sprinta.com.br/experience_service/'

// window.URL_API = 'http://homolog.sprinta.com.br/api/'
// window.URL_API_USER = 'http://homolog.sprinta.com.br/profile-service/'
// window.URL_API_EVENT = 'http://homolog.sprinta.com.br/event-service/'
// window.URL_API_CHALLENGE = 'http://homolog.sprinta.com.br/challenge-service/'
// window.URL_API_EXPERIENCE = 'http://homolog.sprinta.com.br/experience-service/'

window.URL_API_TIMELINE = window.URL_API
window.URL_ASSETS_BASE = 'https://www.sprinta.com.br/'
window.URL_BASE_OLD = 'https://www.sprinta.com.br/'
window.eventURL   = 'https://app.sprinta.com.br/event'
window.createEvent = 'https://app.sprinta.com.br/create/event'
window.URL_CHECKOUT = 'https://checkout.sprinta.com.br/'
window.USER_PROFILE = 'https://app.sprinta.com.br/user/'


// WEBPACK FOOTER //
// ./src/_config.js